import React from "react";
import styled from "styled-components";

import { Link } from "react-router-dom";

import { colors } from "../utils/theme";

const Container = styled.div`
  width: 100%;
  background: linear-gradient(to top, ${colors.blanco} 55%, ${colors.gris} 40%);
  @media (max-width: 500px) {
    background: linear-gradient(
      to top,
      ${colors.blanco} 50%,
      ${colors.gris} 50%
    );
  }
`;

const Session = styled.div`
  width: 90%;
  margin: 0 auto;
`;

const Title = styled.div`
  width: 100%;
  text-align: center;
  font-family: "Roboto", sans-serif;

  h1 {
    padding: 2rem 0;
    color: ${colors.third};
    font-size: 3rem;
    font-weight: 400;
    @media (max-width: 500px) {
      font-size: 2rem;
    }
  }
`;

const ContainerCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  align-content: center;
`;

const Card = styled.div`
  flex: 30%;
  background-color: #fbfbfb;
  border-radius: 10px;
  font-family: "Roboto", sans-serif;
  box-shadow: 1px 1px 7px 1px ${colors.gris2};

  @media (max-width: 768px) {
    flex: 100%;
  }
`;

const ContainerCard = styled.div`
  width: 85%;
  margin: 0 auto;
  /* & > * {
    outline: 1px solid red;
  } */
  h3 {
    width: 100%;
    text-align: center;
    margin-top: 1.5rem;
    font-size: 1.3rem;
    margin-bottom: 0;
    color: ${colors.third};
    height: 2.8rem;
    font-weight: bold;
    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
  }

  .paragraph1 {
    width: 100%;
    text-align: center;
    font-size: 1.3rem;
    margin-bottom: 2rem;
    line-height: 1.8rem;
    min-height: 6rem;
    color: ${colors.fifth};
  }

  .paragraph2 {
    width: 100%;
    font-weight: bold;
    text-align: center;
    font-size: 1.1rem;
    color: ${colors.fifth};
  }

  .link {
    display: block;
    width: 100%;
    margin: 1.5rem auto;
    border-radius: 20px;
    padding: 5px;
    background-color: ${colors.primary};
    color: ${colors.blanco};
    border: none;
    font-weight: bold;
    transition: background-color 0.5s ease-in-out;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    &:hover {
      background-color: #9c010e;
    }
  }
`;

const AppointmentScheduling = (): JSX.Element => {
  const hostname = window.location.hostname;
  const isNotProduction = hostname !== "mifisico-prod.pahventure.dev";
  return (
    <Container>
      <Session>
        <Title>
          <h1>AGENDA TU CITA</h1>
        </Title>

        <ContainerCards>
          <Card>
            <ContainerCard>
              <h3>PACIENTE NUEVO</h3>
              <p className="paragraph1">
                Si vas a programar tu cita por primera vez o tiene una nueva orden medica.
              </p>
              <p className="paragraph2">¡Agenda tu cita aquí!</p>
              <Link className="link" to="/PacienteNuevo">
                AGENDA TU CITA
              </Link>
            </ContainerCard>
          </Card>

          <Card>
            <ContainerCard>
              <h3>PACIENTE EN TRATAMIENTO</h3>
              <p className="paragraph1">
                Si ya has asistido a tu primera sesión de terapia física,
                debes seguir agendando tu cita por esta pestaña.

              </p>
              <p className="paragraph2">¡Continúa tu cita!</p>
              <Link className="link" to="/Continuidad">
                Sigue tu tratamiento
              </Link>
            </ContainerCard>
          </Card>

          {isNotProduction && (
            <Card>
              <ContainerCard>
                <h3>CANCELACIÓN DE CITA</h3>
                <p className="paragraph1">
                  Cancela tu cita mínimo con 3 horas de
                  anticipación y podrás reprogramarla.
                </p>
                <p className="paragraph2">¡Cancela tu cita!</p>
                <Link className="link" to="/CancelarCita">
                  CANCELAR TU CITA
                </Link>
              </ContainerCard>
            </Card>
          )}
        </ContainerCards>
      </Session>
    </Container>
  );
};

export default AppointmentScheduling;
